import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useLanguage } from "../i18n";
import { copy } from "../siteContent";

export default function SiteHeader() {
  const { language, setLanguage } = useLanguage();
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const t = copy[language];

  useEffect(() => setMenuOpen(false), [location.pathname, location.hash]);

  useEffect(() => {
    if (!menuOpen) return undefined;
    const closeOnEscape = (event) => {
      if (event.key === "Escape") setMenuOpen(false);
    };
    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, [menuOpen]);

  const navItems = [
    [t.nav.services, "/#services"],
    [t.nav.work, "/#projects"],
    [t.nav.cases, "/#cases"],
    [t.nav.contact, "/#contact"],
  ];

  return (
    <header className="site-header">
      <div className="header-shell">
        <Link className="brand" to="/" aria-label={t.nav.home}>
          <span className="brand-mark" aria-hidden="true">
            <span>P</span>
            <i />
          </span>
          <span className="brand-name">PK-FORENSICS</span>
        </Link>

        <nav className={`primary-nav ${menuOpen ? "is-open" : ""}`} aria-label="Primary">
          {navItems.map(([label, href]) => (
            <Link key={href} to={href}>{label}</Link>
          ))}
          <a className="nav-contact-mobile" href="mailto:jarmo@pk-forensics.fi">
            jarmo@pk-forensics.fi
          </a>
        </nav>

        <div className="header-actions">
          <div className="language-switch" role="group" aria-label={t.nav.language}>
            {[
              ["fi", "FI"],
              ["en", "EN"],
            ].map(([value, label]) => (
              <button
                key={value}
                type="button"
                className={language === value ? "is-active" : ""}
                aria-pressed={language === value}
                onClick={() => setLanguage(value)}
              >
                {label}
              </button>
            ))}
          </div>
          <button
            className="menu-toggle"
            type="button"
            aria-label={menuOpen ? t.nav.close : t.nav.menu}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((value) => !value)}
          >
            {menuOpen ? <X size={21} /> : <Menu size={21} />}
          </button>
        </div>
      </div>
    </header>
  );
}
